import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/stores/auth';
import { api } from '../lib/api/client';
import { Button, Card, CardHeader, CardBody, Input } from '../lib/design-system/components';
import './Auth.css'; // Reuse auth styles

export default function VerifyEmail() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [code, setCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setIsLoading(true);

    try {
      await api.post('/auth/verify-email', { code });
      setSuccess('Email verified successfully!');

      setTimeout(() => {
        navigate('/unlock');
      }, 1500);
    } catch (err: any) {
      setError(err.message || 'Verification failed');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-content">
        <div className="auth-header">
          <h1 className="heading-1">Verify Your Email</h1>
          <p className="text-large text-secondary">
            We've sent a verification code to {user?.email}
          </p>
        </div>

        <Card elevation="lg" padding="lg">
          <CardHeader>
            <h2 className="heading-3">Enter Verification Code</h2>
            <p className="text-secondary">Check your email for the 6-digit code</p>
          </CardHeader>

          <CardBody>
            <form onSubmit={handleSubmit} className="auth-form">
              <Input
                label="Verification Code"
                type="text"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                required
                fullWidth
                placeholder="123456"
                maxLength={6}
              />

              {success && (
                <div className="success-message">
                  <span className="text-small">✓ {success}</span>
                </div>
              )}

              {error && (
                <div className="error-message">
                  <span className="text-small">{error}</span>
                </div>
              )}

              <Button
                type="submit"
                variant="primary"
                size="lg"
                fullWidth
                isLoading={isLoading}
              >
                Verify Email
              </Button>
            </form>
          </CardBody>
        </Card>

        <p className="text-small text-tertiary auth-footer">
          💡 For development: Check the console or registration response for your code
        </p>
      </div>
    </div>
  );
}
